export const radii = {
  md: '0.5rem',
}
